import type { Paywall } from '~/interfaces/paywall';
import type { Post } from '~/interfaces/post';
import type { Publication } from '~/interfaces/publication';
import type { Subscription } from '~/interfaces/subscriptions';
import FreeGatedContent from '~/pages/post/FreeGatedContent';
import PremiumGatedContent from '~/pages/post/PremiumGatedContent';

interface GatedContentProps {
  post: Post;
  publication: Publication;
  isGatedContentDisabled: boolean;
  subscription?: Subscription;
  paywall: Paywall | null;
}

const GatedContent = ({ post, publication, isGatedContentDisabled, subscription, paywall }: GatedContentProps) => {
  if (post.hide_premium_post && paywall) {
    return <PremiumGatedContent subscription={subscription} publication={publication} paywall={paywall} />;
  }

  if (post.contains_subscriber_break && !isGatedContentDisabled) {
    return (
      <FreeGatedContent
        title={post.email_capture_title}
        message={post.email_capture_message}
        cta={post.email_capture_cta}
        publication={publication}
        theme="subscribe-gate"
      />
    );
  }

  return null;
};

export default GatedContent;
